/**
 * When admin sets Product Code to include "SOON", the dealer UI shows the reward as unavailable.
 */
export function isRewardComingSoon(reward) {
  const pc = reward?.product_code;
  if (pc == null || typeof pc !== 'string') return false;
  return pc.toUpperCase().includes('SOON');
}
